import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TutorialSlide} from "../core/models";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {Router} from "@angular/router";
import {CoreService} from "../core/services/core.service";

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss']
})
export class TutorialComponent implements OnInit {

  @ViewChild('video') video;

  slides: TutorialSlide[] = [];
  currentIndex: number = 0;
  current: TutorialSlide;
  html: SafeHtml;
  showNextTime: boolean = true;

  constructor(public dialogRef: MatDialogRef<TutorialComponent>,
              private coreService: CoreService,
              private _sanitizer: DomSanitizer,
              private router: Router,
              @Inject(MAT_DIALOG_DATA) private data: any) {

    dialogRef.disableClose = true;

    this.slides = data.slides;
    this.showNextTime = data.showNextTime;
    this.selectSlide(0);
  }

  ngOnInit(): void {
  }

  selectSlide(i) {


    this.currentIndex = i;
    this.current = this.slides[i];
    this.html = this._sanitizer.bypassSecurityTrustHtml(this.current.body);
    if (this.current && this.current.video) {
      setTimeout(() => {
        if(this.video.nativeElement) {
          this.video.nativeElement.muted = true;
          this.video.nativeElement.play();
          this.video.nativeElement.onended = (event) => {
            this.selectNext();
          };
        }
      }, 300);
    }
  }

  selectPrev() {
    if(this.currentIndex > 0) {
      this.selectSlide(this.currentIndex - 1);
    }
  }

  selectNext() {
    if(this.currentIndex < this.slides.length) {
      this.selectSlide(this.currentIndex + 1);
    }
  }

  openDetail() {
    const link = this.current.link == '' ? 'help' : (this.current.link.startsWith('/') ? this.current.link.substr(1) : this.current.link);
    this.router.navigate([link]);
    this.dialogRef.close();
  }

  changeNextTime(event) {
    this.showNextTime = event.checked;
  }

  close() {
     this.coreService.viewTutorial(this.showNextTime).subscribe(() => {
       this.dialogRef.close(this.showNextTime);
       }
     );
  }
}
